<template>
  <div
    v-loading="isComponentLoading"
    :class="{'tour-active': tourActive, 'height-100': isSidebarShown}"
    class="site-wrapper">
    <include-exclude-mobile v-if="$device.isMobile"/>
    <beta-modal
      v-if="isBetaModalOpen"
      @close="showFirstLoginTour"/>
    <preview-modal />
    <navbar/>

    <div class="container site-container">
      <nuxt class="default-layout"/>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import IncludeExcludeMobile from '~/components/layouts/IncludeExcludeMobile'
import AlertBanner from '~/components/common/AlertBanner'
import Navbar from '~/components/layouts/Navbar'
import BetaModal from '~/components/layouts/BetaModal'
import AdvancedSearchModal from '~/components/layouts/AdvancedSearchModal'
import PreviewModal from '~/components/common/PreviewModal'
import cioPageTracking from '~/plugins/mixins/cioPageTracking'
import { initReferrerCookie } from '~/middleware/check-referrer'
import { offlineTracking } from '~/mixins'

export default {
  components: {
    Navbar,
    IncludeExcludeMobile,
    BetaModal,
    AdvancedSearchModal,
    PreviewModal,
    AlertBanner
  },

  mixins: [cioPageTracking, offlineTracking],
  middleware: [initReferrerCookie],
  data() {
    return {
      isOpen: true,
      openMigrationModal: false
    }
  },
  computed: {
    ...mapState(['inFullscreen']),
    ...mapState(['isBetaModalOpen', 'isSidebarShown']),
    ...mapState('tours', ['tourActive']),
    ...mapState('auth', ['user']),
    ...mapState('search', ['isComponentLoading']),

    isSearching() {
      return this.$actions.pending('search/search')
    }
  },

  watch: {
    $route(to, from) {
      const root = document.getElementsByTagName('html')[0]

      if (to.path !== from.path) {
        if (!to.path.includes('/search')) {
          this.setSidebarContent(false)

          root.classList.remove('overflow-hidden')
        }
        this.setInFullscreen(false)
      }

      if (to.query.view === 'analytics' || to.query.view === 'overview') {
        root.style.height = 'auto'
        return
      }

      root.style.height = null
    },

    isSearching(searching) {
      if (searching) {
        document.documentElement.style.overflow = 'hidden'
        return
      }
      document.documentElement.style.overflow = 'auto'
    },

    inFullscreen(isFullscreen) {
      const root = document.getElementsByTagName('html')[0]
      if (isFullscreen) {
        root.classList.add('overflow-hidden')
        return
      }

      root.classList.remove('overflow-hidden')
    }
  },

  mounted() {
    // @TODO https://github.com/nuxt/nuxt.js/issues/2738
    if (window) {
      window.history.scrollRestoration = 'auto'
    }

    this.countDownRefresh()
    this.$keyboardEvents.register()

    // initialize migration modal
    this.fetchRecurlySubscriptions()
  },

  beforeDestroy() {
    this.$keyboardEvents.unregister()
  },

  methods: {
    ...mapActions('userSubscriptions', ['fetchRecurlySubscriptions']),
    ...mapMutations(['setSidebarContent', 'setInFullscreen']),
    ...mapMutations('tours', ['toggleTour']),
    ...mapActions(['countDownRefresh']),
    ...mapActions('accounts', ['fetchAlerts', 'updateAlerts']),

    showFirstLoginTour() {
      this.toggleTour({
        tour: 'FirstLoginTour',
        show: !this.user.login_tour_state
      })
    }

    // beforeEnter() {
    //   this.$store.commit('setIsSideBarShown', false)
    // },

    // afterLeave() {
    //   this.$store.commit('setIsSideBarShown', true)
    // }
  }
}
</script>

<style src="~/assets/scss/sections/sidebar/advanced-search-drawer.scss" lang="scss"/>
<style src="~/assets/scss/sections/sidebar/sidebar.scss" lang="scss"/>
